export default __webpack_public_path__ + "static/media/D.C fan.ed3eeb65.jpg";